import { createSliderWithBullets } from "@/scripts/components/sliders";

document.querySelectorAll(".element-photogalleryslider").forEach((el) => {
  const sliderPagination = el.querySelector(".slider-pagination");
  const asTwoColumn = el.querySelector("[data-two-column]");
  let swiper;

  if (asTwoColumn) {
    createSliderWithBullets(el, {
      effect: "slide",
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        768: {
          spaceBetween: 20,
          slidesPerView: 2.2,
        },
        1020: {
          spaceBetween: 35,
          slidesPerView: 2.5,
        },
      },
    });
  } else {
    createSliderWithBullets(el, {
      effect: "coverflow",
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 0.5,
        slideShadows: false,
      },
      slidesPerView: 1.3,
      centeredSlides: true,
      breakpoints: {
        768: {
          spaceBetween: 50,
        },
        1020: {
          spaceBetween: 200,
          coverflowEffect: {
            rotate: 0,
            stretch: 0,
            depth: 500,
            modifier: 0.5,
            slideShadows: false,
          },
        },
      },
    });
  }
});
